export default "__VITE_ASSET__DMIUEl4w__"